import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CtaButton } from './CtaButton';
import { CHECKOUT_URLS } from '../data/checkout';
export function StickyCta() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 900);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <AnimatePresence data-id="element-293" data-mp="3ud54jjuwfurq">
      {visible && <motion.div initial={{
      y: 72,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 72,
      opacity: 0
    }} transition={{
      duration: 0.22,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-40 border-t border-beige-deep bg-cream/95 px-4 py-3 backdrop-blur" data-id="element-294" data-mp="3ubu1xnd6wt27">
          <div className="mx-auto flex max-w-5xl items-center justify-between gap-4" data-id="element-295" data-mp="gxgxx3om9xqo">
            <div className="hidden sm:block" data-id="element-296" data-mp="gzjuy7o6sr4w">
              <p className="font-display text-sm font-bold text-petrol" data-id="element-297" data-mp="76xe2cos0w69">
                MegaPack completo — 6 Tomos + 6 Bonos
              </p>
              <p className="text-xs text-body-muted" data-id="element-298" data-mp="24y94yde1r77">
                <span className="line-through" data-id="element-299" data-mp="gwqmx5xjax6t">$51.000</span> ·{' '}
                <span className="font-bold text-cta-hover" data-id="element-300" data-mp="c58nimb5t4ny">$19.990 ARS</span> · Garantía 7 días
              </p>
            </div>
            <CtaButton href={CHECKOUT_URLS.megapack} size="md" className="w-full sm:w-auto" data-id="element-301" data-mp="pvc6n4eqsi96">
              Quiero mi MegaPack
            </CtaButton>
          </div>
        </motion.div>}
    </AnimatePresence>;
}